import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { VitalPlate, VitalPlateData } from '../plate';
import { useSessionRoomState } from '../../../../context';

export const VitalTemperature: FC = () => {
  const { t } = useTranslation(['session-room']);
  const { vitalsData } = useSessionRoomState();
  const value = useMemo(() => {
    const temperature = vitalsData.temperature?.Value;
    if (temperature === undefined || temperature === null) {
      return '-';
    }

    return Number(temperature.toFixed(2));
  }, [vitalsData.temperature]);

  return (
    <VitalPlate>
      <VitalPlateData
        title={t('session-room:SENSORS.TEMP')}
        units="°F"
        color="#f86623"
        value={value}
      />
    </VitalPlate>
  );
};
